import { render, staticRenderFns } from "./riskRuleEdit.vue?vue&type=template&id=a4802f74"
import script from "./riskRuleEdit.vue?vue&type=script&lang=js"
export * from "./riskRuleEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports